// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessRetailShop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5 3a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 5 4v-.5a.5.5 0 0 1 .5-.5zm.232 2a.5.5 0 0 1 .416.223l1.768 2.651a.5.5 0 0 1 .084.277V9.5l-.001.002a1.8 1.8 0 0 1-3.6-.001 1.803 1.803 0 0 1-1.8 1.768A1.798 1.798 0 0 1 13.8 9.5a1.804 1.804 0 0 1-1.8 1.768A1.799 1.799 0 0 1 10.2 9.5V9.5l-.002.001a1.8 1.8 0 0 1-3.6 0A1.8 1.8 0 0 1 3 9.5V8.151a.5.5 0 0 1 .084-.277l1.768-2.651A.5.5 0 0 1 5.268 5zM4 12.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H18v-5.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V21H4.5a.5.5 0 0 1-.5-.5zM6.11 15a.11.11 0 0 0-.11.11v3.78c0 .06.05.11.11.11h5.78c.06 0 .11-.05.11-.11v-3.78a.11.11 0 0 0-.11-.11z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessRetailShop;
